/**
 * Notification constants
 *
 * String constants that participate in notification document identity. Values
 * are pulled verbatim from Flutter and must never be invented — a mismatch here
 * changes the deterministic notification doc id and breaks parity with the LIVE
 * app.
 */

/**
 * Suffix appended to a user's Firebase uid to form the deterministic
 * `liveStarted` / `liveEnded` notification document id
 * (`<uid>_live`). One live-notification doc per broadcaster is upserted, so the
 * id is stable across the start/end pair.
 *
 * Mirrors Flutter's `AppConstants.liveNotificationSuffix = "_live"`
 * (lib/domain/constants/app_constants.dart:40), used at
 * lib/presentation/screens/community/community_screen.dart:634.
 */
export const LIVE_NOTIFICATION_SUFFIX = '_live';
